module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_easy_blogging_everywhere.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_easy_blogging_everywhere.png
// module id = PS65
// module chunks = 0